// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITriggerConfigRenewalDto
 */
export interface ITriggerConfigRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof ITriggerConfigRenewalDto
     */
    trigger_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITriggerConfigRenewalDto
     */
    trigger_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITriggerConfigRenewalDto
     */
    trigger_category_type?: string;
    /**
     * 
     * @type {number}
     * @memberof ITriggerConfigRenewalDto
     */
    threshold_amount?: number;
}

/**
 * Check if a given object implements the ITriggerConfigRenewalDto interface.
 */
export function instanceOfITriggerConfigRenewalDto(value: object): value is ITriggerConfigRenewalDto {
    return true;
}

export function ITriggerConfigRenewalDtoFromJSON(json: any): ITriggerConfigRenewalDto {
    return ITriggerConfigRenewalDtoFromJSONTyped(json, false);
}

export function ITriggerConfigRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITriggerConfigRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'trigger_id': json['trigger_id'] == null ? undefined : json['trigger_id'],
        'trigger_name': json['trigger_name'] == null ? undefined : json['trigger_name'],
        'trigger_category_type': json['trigger_category_type'] == null ? undefined : json['trigger_category_type'],
        'threshold_amount': json['threshold_amount'] == null ? undefined : json['threshold_amount'],
    };
}

export function ITriggerConfigRenewalDtoToJSON(json: any): ITriggerConfigRenewalDto {
    return ITriggerConfigRenewalDtoToJSONTyped(json, false);
}

export function ITriggerConfigRenewalDtoToJSONTyped(value?: ITriggerConfigRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trigger_id': value['trigger_id'],
        'trigger_name': value['trigger_name'],
        'trigger_category_type': value['trigger_category_type'],
        'threshold_amount': value['threshold_amount'],
    };
}

